export const RETRIEVE_SOLAR_LOCATIONS = 'RETRIEVE_SOLAR_LOCATIONS';
export const LOCATION_DETAILS_PAGE_SIZE = 'LOCATION_DETAILS_PAGE_SIZE';
export const LOCATION_DETAILS_ORDER_BY = 'LOCATION_DETAILS_ORDER_BY';
export const LOCATION_DETAILS_DIRECTION = 'LOCATION_DETAILS_DIRECTION';
export const SET_PANEL_MODULE = 'SET_PANEL_MODULE';
export const SET_PANEL_MODULES = 'SET_PANEL_MODULES';
export const UPDATE_PANEL_MODULES = 'UPDATE_PANEL_MODULES';
export const PANEL_MODULE_IS_EDIT = 'PANEL_MODULE_IS_EDIT';